/* Divina Closet – ingyenes szállítás számláló (termékoldal, kosár panel, kosár oldal) */
(function () {
  var cfg = window.DivinaFreeShip || {};
  var T = +cfg.threshold || 0;
  if (!T) return;
  var fmt = cfg.format || '{{amount_no_decimals}} Ft';
  var total = null, busy = false, again = false;

  function money(cents) {
    var v = cents / 100;
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var withDec = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec)
      .replace(/\{\{\s*amount[^}]*\}\}/, noDec);
  }
  var TRUCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>';
  var CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function ensureSlots() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner && !inner.querySelector('.dvfs--drawer')) {
      var hd = inner.querySelector('.drawer__header');
      if (hd) { var d = document.createElement('div'); d.className = 'dvfs--drawer'; d.setAttribute('data-freeship', ''); hd.insertAdjacentElement('afterend', d); }
    }
    var page = document.getElementById('main-cart-items');
    if (page && !document.querySelector('.dvfs--page')) {
      var p = document.createElement('div'); p.className = 'dvfs--page'; p.setAttribute('data-freeship', '');
      page.parentNode.insertBefore(p, page);
    }
  }

  function paint() {
    if (total === null) return;
    ensureSlots();
    var left = Math.max(0, T - total);
    var pct = Math.min(100, Math.round(total * 100 / T));
    var done = left === 0;
    var msg = done
      ? CHECK + '<span><b>Ingyenes szállítás</b> jár a rendelésedre!</span>'
      : TRUCK + '<span>' + (total > 0 ? 'Még <b>' + money(left) + '</b>, és <b>ingyenes</b> a szállítás!' : '<b>Ingyenes szállítás</b> ' + money(T) + ' feletti rendelésnél') + '</span>';
    document.querySelectorAll('[data-freeship]').forEach(function (el) {
      if (!el.classList.contains('dvfs')) {
        el.classList.add('dvfs');
        el.innerHTML = '<p class="dvfs-msg"></p><div class="dvfs-track" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span></span></div>';
      }
      var m = el.querySelector('.dvfs-msg');
      if (m.getAttribute('data-k') !== String(total)) { m.innerHTML = msg; m.setAttribute('data-k', String(total)); }
      el.classList.toggle('is-done', done);
      var bar = el.querySelector('.dvfs-track');
      bar.setAttribute('aria-valuenow', String(pct));
      var fill = bar.querySelector('span');
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
      el.hidden = false;
    });
  }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; paint(); })
      .catch(function () {})
      .finally(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 250); }
  function watch(el) {
    if (!el || el.__dvfsWatched) return;
    el.__dvfsWatched = true;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (n.closest && n.closest('.dvfs')) continue;
        soon(); return;
      }
    }).observe(el, { childList: true, subtree: true });
  }

  window.DivinaFreeShip = Object.assign(cfg, { refresh: refresh, paint: paint });

  function init() {
    watch(document.querySelector('cart-drawer'));
    var mci = document.getElementById('main-cart-items');
    watch(mci && mci.parentNode);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
